import API from '../../../manager/API';
import { dispatch } from '../../hooks';
import slice from './slice';

const { setModelAddingStatusData } = slice.actions;

const modelAddingStatus = (url: any) => async () => {
  try {
    const response = await API.modelAddingStatus.modelAddingStatus(url);
    dispatch(setModelAddingStatusData(response.data));
    return { response, status: response.status, data: response.data };
  } catch (error: any) {
    return { status: error.response.status, data: error.response.data };
  }
};

export default {
  modelAddingStatus
};
